import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  public user: BehaviorSubject<any>;
  private baseTitle = `${document.title}`;

  constructor(private apiService: ApiService, private titleService: Title) {
    this.user = new BehaviorSubject((<any>window).user);

    // If logged in, continue refreshing user
    if (this.user.getValue()) {
      setInterval(async () => {
        await this.pollMe();
      }, 15000);
    }
  }

  public getUser() {
    return this.user.getValue();
  }

  public async refreshUser() {
    await this.pollMe();
  }

  private async pollMe() {
    try {
      const { user }: any = await this.apiService
        .get('user/get-me')
        .toPromise();

      if (user.unread_notifications.length) {
        this.titleService.setTitle(
          `(${user.unread_notifications.length}) ${this.baseTitle}`,
        );
      } else {
        if (this.getUser().unread_notifications.length) {
          this.titleService.setTitle(this.baseTitle);
        }
      }

      this.user.next(user);
    } catch (e) {
      console.error(e);
    }
  }
}
